import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: { padding: '1rem 2.5rem' },
    buttonContainer: { paddingTop: '2.5rem' },
    smallPaddedText: { padding: '.25rem 0' },
    paddedText: { padding: '.5rem 0' },
    largePaddedText: {
        paddingTop: '.8rem',
        paddingBottom: '.3rem'
    },
    submitText: { fontSize: '28px' },
    amountText: { fontSize: '40px' },
    disclaimerText: { fontSize: '18px' },
    processingText: { padding: '2rem 0' },
    table: {
        borderCollapse: 'separate' as const,
        borderSpacing: '.5rem'
    },
    tableRow: { marginBottom: '.3rem' },
    tableLabelCell: {
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
            '#bec6d470',
        fontWeight: 'bold' as const
    },
    tableCell: {
        border: 'none' as const,
        paddingTop: '.3rem',
        paddingBottom: '.3rem'
    }
});